"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-one/sections/reasonsSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type ReasonsSection46sItem = {
    key: Key | null | undefined;
    /** Detected variants: "avatar bg-soft-orange" | "avatar bg-soft-primary" | "avatar bg-light" */
    className: string;
    /** Detected variants: "isax isax-tag-user5 text-orange" | "isax isax-voice-cricle text-primary" | "isax isax-wallet-add-15 text-cyan" */
    i0ClassName: string;
    /** Detected variants: "Follow-Up Care" | "Patient-Centered" | "Convenient Access" */
    h30Text: ReactNode;
    /** Detected variants: "We ensure continuity of care through regular follow-ups and communication, helping you stay on track with health goals." | "We prioritize your comfort and preferences, tailoring our services to meet your individual needs and Care from Our Experts" | "Easily book appointments online or through our dedicated customer service team, with flexible hours to fit your schedule." */
    p0Text: ReactNode;
    /** Detected variants: "col-lg-4 col-md-6" */
    divClassName?: string;
    /** Detected variants: "reason-item wow zoomIn" */
    div0ClassName?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
};
export type HomeOneReasonsSectionGeneratedProps = {
    divDiv0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: ReasonsSection46sItem) => Partial<ComponentProps<"h3">>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Why Book With Us" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Compelling" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    /** Default: "to Choose" */
    sectionDiv0Div0H20H2Text2?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Reasons" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    /** Default: "element" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/reason-bg-one.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "element" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/reason-bg-two.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    reasonsSection46s: ReasonsSection46sItem[];
    reasonsSection46sItemWrapper?: (item: ReasonsSection46sItem, content: ReactNode) => ReactNode;
    reasonsSection46sRenderer?: (defaultNode: ReactNode) => ReactNode;
    reasonsSection46sH3Visible?: boolean;
    reasonsSection46sH3Renderer?: (item: ReasonsSection46sItem, defaultNode: ReactNode) => ReactNode;
    reasonsSection46sH3Props?: Partial<ComponentProps<"h3">> | ((item: ReasonsSection46sItem) => Partial<ComponentProps<"h3">>);
};

const HomeOneReasonsSectionGenerated: FC<HomeOneReasonsSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Why Book With Us",
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Compelling",
    sectionDiv0Div0H20H2Text2 = "to Choose",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "Reasons",
    sectionImageWithBasePath0ImageAlt = "element",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/reason-bg-one.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "element",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/reason-bg-two.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    divDiv0H30H3Props,
    sectionDiv0Div1ClassName,
    reasonsSection46s,
    reasonsSection46sItemWrapper,
    reasonsSection46sRenderer,
    reasonsSection46sH3Visible,
    reasonsSection46sH3Renderer,
    reasonsSection46sH3Props,
}) => {
    return (
        <section className="reason-section section">
            <div className="container">
                <div className="section-header section-header-one text-center wow slideInLeft" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    <div className="title">{sectionDiv0Div0Div0DivText}</div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {" "}
                            {sectionDiv0Div0H20H2Text}
                            <span className="text-primary">{sectionDiv0Div0H20Span0SpanText}</span>
                            {sectionDiv0Div0H20H2Text2}
                        </h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row g-4 justify-content-center"}>
                    {renderCollectionNode(
                        reasonsSection46s,
                        (item: ReasonsSection46sItem) => (
                            <div className={item.divClassName ?? "col-lg-4 col-md-6"} key={item.key}>
                                <div className={item.div0ClassName ?? "reason-item wow zoomIn"} data-wow-duration={item.dataWowDuration ?? "1s"}>
                                    <div className={item.className}>
                                        <i className={item.i0ClassName} />
                                    </div>
                                    {renderItemNode(reasonsSection46sH3Visible, reasonsSection46sH3Renderer, item, (
                                        <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof reasonsSection46sH3Props === "function" ? reasonsSection46sH3Props(item) : (reasonsSection46sH3Props ?? {}))} {...(typeof divDiv0H30H3Props === "function" ? divDiv0H30H3Props(item) : (divDiv0H30H3Props ?? {}))}>{item.h30Text}</h3>
                                    ))}
                                    <p>{item.p0Text}</p>
                                </div>
                            </div>
                        ),
                        reasonsSection46sItemWrapper,
                        reasonsSection46sRenderer
                    )}
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid element-01" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="img-fluid element-02" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeOneReasonsSectionGenerated;
